export const syntaxError = () =>
    `<p>? <span class="lightRed">SYNTAX ERROR</span>: Please enter the command <span class="white">HELP</span> to show the commands list.</p>`;
